export default __webpack_public_path__ + "static/media/profile_placeholder.c56624b9.png";